import React from "react";
import { Box, Image, Button, ResponsiveContext } from "grommet";
import { Congratulations } from "../Congratulations";
import { Partner } from "./../ApplyFooter";
import { ThankYou } from "../ThankYou";
import { ShareRounded } from "grommet-icons";

const Career = () => (
  <ResponsiveContext.Consumer>
    {(size) =>
      size === "small" ? (
        <Box>
          <Partner />
        </Box>
      ) : (
        <Box height="30vh">
          <Partner />
        </Box>
      )
    }
  </ResponsiveContext.Consumer>
);
// export const Career1 = () => (
//   <Box justify="between" height="100vh" pad={{ bottom: "medium" }}>
//     <Box width="100%">
//       <ThankYou />
//       <Box width="medium" pad={{ top: "small" }}>
//         <Button
//           size="small"
//           target="_blank"
//           icon={<ShareRounded size="small" />}
//           reverse
//           href="http://localhost:8000/jobs/categories"
//           label="Learn more about this "
//         />
//       </Box>
//     </Box>

//     <Box pad={{ horizontal: "large" }} gap="xsmall">
//       <Partner />
//     </Box>
//   </Box>
// );
export default Career;
